import { render, staticRenderFns } from "./fmc5.vue?vue&type=template&id=08c52f8e&scoped=true"
import script from "./fmc5.vue?vue&type=script&lang=js"
export * from "./fmc5.vue?vue&type=script&lang=js"
import style0 from "./fmc5.vue?vue&type=style&index=0&id=08c52f8e&prod&lang=scss"
import style1 from "./fmc5.vue?vue&type=style&index=1&id=08c52f8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c52f8e",
  null
  
)

export default component.exports